import * as React from 'react';
import * as moment from 'moment';
import { Badge } from '@mui/material';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';

const CalendarDayRenderer = (
	props: PickersDayProps<moment.Moment> & { isDisabled, getDayColor, getDayIcon }) => {
	const { isDisabled, getDayColor, getDayIcon, day, outsideCurrentMonth, ...other } = props;

	return (
		<Badge
			key={props.day.toString()}
			overlap='circular'
			badgeContent={!outsideCurrentMonth ? getDayIcon(day) : undefined}
		>
			<PickersDay {...other}
			            outsideCurrentMonth={outsideCurrentMonth}
			            disabled={isDisabled(day)}
			            day={day}
			            sx={{ backgroundColor: getDayColor(day) }}/>
		</Badge>
	);
};

export default React.memo(CalendarDayRenderer);